var ko = require('knockout');
var FilterViewModel = require('./filter.vm.js');

function LearnArticlesViewModel(page, pageSize, categories, total, listingPageId) {
    var self = this;

    self.page = ko.observable(page);
    self.pageSize = ko.observable(pageSize);
    self.totalArticles = ko.observable(total);
    self.listingPageId = ko.observable(listingPageId);
    self.loadingArticles = ko.observable(false);
    self.xhr = null;

    self.activeFilterItems = ko.observableArray([]);
    self.categoryFilters = ko.observableArray([]);

    categories.forEach(function (category) {
        self.categoryFilters().push(new FilterViewModel(category));
    });

    self.activeCategoryFilters = ko.computed(function () {
        return ko.utils.arrayFilter(self.categoryFilters(), function (filter) {
            return filter.isActive();
        });
    }, this);

    self.anyActiveFilters = ko.computed(function () {
        return self.activeCategoryFilters().length > 0;
    }, this);

    self.isLoadingArticles = ko.computed(function() {
        return self.loadingArticles();
    }, this);

    self.clearCategoryFilters = function () {
        for (var i = 0; i < self.categoryFilters().length; i++) {
            self.categoryFilters()[i].isActive(false);
        }
    }

    self.clearActiveFilterItems = function () {
        self.activeFilterItems([]);
    }

    self.clearAllFilters = function () {
        self.clearCategoryFilters();
        self.clearActiveFilterItems();
    };

    self.toggleFilter = function (data) {
        var filterArray = self.activeFilterItems();

        if (data.isActive()) {
            for (var i = 0; i < self.categoryFilters().length; i++) {
                if (self.categoryFilters()[i].name() === data.name()) {
                    self.categoryFilters()[i].isActive(false);
                    var temp = [];

                    filterArray.forEach(function (element) {
                        if (element.name() !== data.name()) {
                            temp.push(element);
                        }
                    });

                    filterArray = temp;
                }
            }
        }
        else {
            for (var i = 0; i < self.categoryFilters().length; i++) {
                if (self.categoryFilters()[i].name() === data.name()) {
                    self.categoryFilters()[i].isActive(true);
                    filterArray.push(self.categoryFilters()[i]);
                }
            }
        }

        self.activeFilterItems(filterArray);
    }

    self.needsPagination = ko.computed(function () {
        return self.totalArticles() > ((self.page() + 1) * self.pageSize());
    }, this);

    self.activeFilterItems.subscribe(function() {
        self.reload(self.page());
    }, this);

    $(".ws-article-listing__load-more").on("click", function() {
        self.reload(Number(self.page()) + 1); //load next page
        return false;
    });

    self.reload = function (pageToGet) {

        if (pageToGet === self.page())
            //must be changing a filter and not loading more; get first page of results with new filter
            pageToGet = 0; 

        self.loadingArticles(true);

        //build object for sending to server
        function FilterGroup(groupName) {
            this.GroupName = groupName;
            this.Items = [];
        };

        var filterGroup = new FilterGroup("Category");

        function Filter(value, isActive) {
            this.Value = value;
            this.Selected = isActive;
        };

        self.categoryFilters().forEach(function (element) {
            filterGroup.Items.push(new Filter(element.name(), element.isActive()));
        });

        function LearnArticleViewModel(pageToGet, pageSize, listingPageId, filters) {
            this.Page = pageToGet;
            this.PageSize = pageSize;
            this.ListingPageId = listingPageId;
            this.Filters = filters;
        }
        var vm = new LearnArticleViewModel(pageToGet, self.pageSize(), self.listingPageId(), [filterGroup]);

        //cancel any existing requests
        if (self.xhr !== null && self.xhr.readyState !== 4) {
            self.xhr.abort();
        }

        self.xhr = $.ajax
        ({
            async: true,
            type: "POST",
            contentType: 'application/json',
            dataType: 'html',
            data: JSON.stringify(vm),
            url: '/api/sitecore/LearnArticleListing/Reload',
            success: function (data) {
                //set the page, render the articles, and set the new total (if changing filter state)
                if (pageToGet === 0) {
                    $(".ws-article-listing__articles").html(data);
                    self.totalArticles(Number($("#articleTotalCount").text()));
                } else {
                    $(".ws-article-listing__articles").append(data);
                }
                self.page(pageToGet);
            },
            error: function (xhr) {
                //display error possibly
            },
            complete: function () {
                self.loadingArticles(false);
            }
        });
    };

};

module.exports = LearnArticlesViewModel;